/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './versionedit.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/material';
import * as i3 from '@angular/cdk';
import * as i4 from '../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i5 from '@angular/flex-layout/flexbox/api/class';
import * as i6 from '@angular/flex-layout/media-query/media-monitor';
import * as i7 from '@angular/forms';
import * as i8 from '@angular/common';
import * as i9 from '../../../../app/containers/versionedit/versionedit.component';
import * as i10 from '@angular/platform-browser';
import * as i11 from '../../../../app/shared/auth.service';
import * as i12 from '@angular/router';
import * as i13 from '../../../../app/shared/constants/baseurl.constants';
import * as i14 from '../../../../app/shared/software.service';
const styles_VersionEditComponent:any[] = [i0.styles];
export const RenderType_VersionEditComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_VersionEditComponent,data:{}});
function View_VersionEditComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(16777216,(null as any),(null as any),22,'div',
      [['mdTooltip','Version ID assigned by the system'],['mdTooltipPosition','after']],
      (null as any),[[(null as any),'longpress'],[(null as any),'touchend']],(_v,en,
          $event) => {
        var ad:boolean = true;
        if (('longpress' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).show()) !== false);
          ad = (pd_0 && ad);
        }
        if (('touchend' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,2).hide(1500)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'md-input-container',
          [['class','version-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,5)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),i1.ɵqud(603979776,
          3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),i1.ɵqud(603979776,
          5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,6,'input',[['class','mat-input-element'],['disabled',''],
              ['id','Id'],['mdInput',''],['name','Id'],['placeholder','Version Id'],
              ['value','Id']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,15)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,15).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,15)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,15)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,20)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,20)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,20)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.version.Id = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          isDisabled:[1,'isDisabled'],model:[2,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,
          (null as any),0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,[[1,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,
          [2,i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {disabled:[0,'disabled'],id:[1,'id'],placeholder:[2,'placeholder']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'after';
    const currVal_1:any = 'Version ID assigned by the system';
    _ck(_v,2,0,currVal_0,currVal_1);
    const currVal_12:any = 'version-full-width';
    _ck(_v,12,0,currVal_12);
    const currVal_26:any = 'Id';
    const currVal_27:any = '';
    const currVal_28:any = _co.version.Id;
    _ck(_v,17,0,currVal_26,currVal_27,currVal_28);
    const currVal_29:any = '';
    const currVal_30:any = 'Id';
    const currVal_31:any = 'Version Id';
    _ck(_v,20,0,currVal_29,currVal_30,currVal_31);
  },(_ck,_v) => {
    const currVal_2:any = (null as any);
    const currVal_3:any = i1.ɵnov(_v,5)._mdInputChild._isErrorState();
    const currVal_4:any = i1.ɵnov(_v,5)._mdInputChild.focused;
    const currVal_5:any = i1.ɵnov(_v,5)._shouldForward('untouched');
    const currVal_6:any = i1.ɵnov(_v,5)._shouldForward('touched');
    const currVal_7:any = i1.ɵnov(_v,5)._shouldForward('pristine');
    const currVal_8:any = i1.ɵnov(_v,5)._shouldForward('dirty');
    const currVal_9:any = i1.ɵnov(_v,5)._shouldForward('valid');
    const currVal_10:any = i1.ɵnov(_v,5)._shouldForward('invalid');
    const currVal_11:any = i1.ɵnov(_v,5)._shouldForward('pending');
    _ck(_v,4,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,
        currVal_9,currVal_10,currVal_11);
    const currVal_13:any = i1.ɵnov(_v,19).ngClassUntouched;
    const currVal_14:any = i1.ɵnov(_v,19).ngClassTouched;
    const currVal_15:any = i1.ɵnov(_v,19).ngClassPristine;
    const currVal_16:any = i1.ɵnov(_v,19).ngClassDirty;
    const currVal_17:any = i1.ɵnov(_v,19).ngClassValid;
    const currVal_18:any = i1.ɵnov(_v,19).ngClassInvalid;
    const currVal_19:any = i1.ɵnov(_v,19).ngClassPending;
    const currVal_20:any = i1.ɵnov(_v,20).id;
    const currVal_21:any = i1.ɵnov(_v,20).placeholder;
    const currVal_22:any = i1.ɵnov(_v,20).disabled;
    const currVal_23:any = i1.ɵnov(_v,20).required;
    const currVal_24:any = (i1.ɵnov(_v,20).ariaDescribedby || (null as any));
    const currVal_25:any = i1.ɵnov(_v,20)._isErrorState();
    _ck(_v,14,1,[currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,
        currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25]);
  });
}
function View_VersionEditComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['class',
      'mat-option'],['role','option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],
      [2,'mat-option-multiple',(null as any)],[2,'mat-active',(null as any)],[8,'id',
          0],[1,'aria-selected',0],[1,'aria-disabled',0],[2,'mat-option-disabled',
          (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,
      en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i4.View_MdOption_0,i4.RenderType_MdOption)),i1.ɵdid(49152,[[37,4]],0,i2.MdOption,
      [i1.ElementRef,[2,i2.MdOptgroup],[2,i2.MATERIAL_COMPATIBILITY_MODE]],{value:[0,
          'value']},(null as any)),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    const currVal_8:any = _v.context.$implicit[1];
    _ck(_v,1,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,1).selected;
    const currVal_2:any = i1.ɵnov(_v,1).multiple;
    const currVal_3:any = i1.ɵnov(_v,1).active;
    const currVal_4:any = i1.ɵnov(_v,1).id;
    const currVal_5:any = i1.ɵnov(_v,1).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,1).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,1).disabled;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
    const currVal_9:any = _v.context.$implicit[0];
    _ck(_v,3,0,currVal_9);
  });
}
function View_VersionEditComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['class',
      'mat-option'],['role','option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],
      [2,'mat-option-multiple',(null as any)],[2,'mat-active',(null as any)],[8,'id',
          0],[1,'aria-selected',0],[1,'aria-disabled',0],[2,'mat-option-disabled',
          (null as any)]],[[(null as any),'onSelectionChange'],[(null as any),'click'],
      [(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    if (('onSelectionChange' === en)) {
      const pd_2:any = ((<any>_co.onProductSelected(_v.context.$implicit,$event)) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },i4.View_MdOption_0,i4.RenderType_MdOption)),i1.ɵdid(49152,[[57,4]],0,i2.MdOption,
      [i1.ElementRef,[2,i2.MdOptgroup],[2,i2.MATERIAL_COMPATIBILITY_MODE]],{value:[0,
          'value']},{onSelectionChange:'onSelectionChange'}),i1.ɵdid(16384,(null as any),
      0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),(_l()(),i1.ɵted(0,['\n            ',' (',')\n        ']))],(_ck,
      _v) => {
    const currVal_8:any = _v.context.$implicit.Name;
    _ck(_v,1,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,1).selected;
    const currVal_2:any = i1.ɵnov(_v,1).multiple;
    const currVal_3:any = i1.ɵnov(_v,1).active;
    const currVal_4:any = i1.ɵnov(_v,1).id;
    const currVal_5:any = i1.ɵnov(_v,1).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,1).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,1).disabled;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
    const currVal_9:any = _v.context.$implicit.Name;
    const currVal_10:any = _v.context.$implicit.UpdateId;
    _ck(_v,3,0,currVal_9,currVal_10);
  });
}
function View_VersionEditComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),16,'md-chip',[['class',
      'mat-chip'],['disabled',''],['role','option'],['tabindex','-1']],[[2,'mat-chip-selected',
      (null as any)],[1,'disabled',0],[1,'aria-disabled',0]],[[(null as any),'click'],
      [(null as any),'focus'],[(null as any),'blur']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._handleClick($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('focus' === en)) {
      const pd_1:any = ((<any>(i1.ɵnov(_v,2)._hasFocus = true)) !== false);
      ad = (pd_1 && ad);
    }
    if (('blur' === en)) {
      const pd_2:any = ((<any>(i1.ɵnov(_v,2)._hasFocus = false)) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,[[58,4]],0,i2.MdChip,[i1.Renderer2,i1.ElementRef],{disabled:[0,
          'disabled']},(null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),7,'span',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,
          'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,
          'em',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['(',')'])),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.removeSelectedProduct(_v.context.$implicit)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'i',[['class','mdi mdi-close-circle-outline']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n        ']))],(_ck,_v) => {
    const currVal_3:any = '';
    _ck(_v,2,0,currVal_3);
    const currVal_6:any = 'mdi mdi-close-circle-outline';
    _ck(_v,15,0,currVal_6);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2).selected;
    const currVal_1:any = (i1.ɵnov(_v,2).disabled || (null as any));
    const currVal_2:any = i1.ɵnov(_v,2).disabled.toString();
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = _v.context.$implicit.UpdateId;
    _ck(_v,7,0,currVal_4);
    const currVal_5:any = _v.context.$implicit.Name;
    _ck(_v,10,0,currVal_5);
  });
}
function View_VersionEditComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'div',[['class',
      'busy-overlay']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-progress-spinner',[['class',
          'busy-spinner mat-progress-spinner'],['color','white'],['mode','indeterminate'],
          ['role','progressbar']],[[1,'aria-valuemin',0],[1,'aria-valuemax',0],[1,
          'aria-valuenow',0],[1,'mode',0]],(null as any),(null as any),i4.View_MdProgressSpinner_0,
          i4.RenderType_MdProgressSpinner)),i1.ɵdid(180224,(null as any),0,i2.MdProgressSpinner,
          [i1.Renderer2,i1.ElementRef,i1.NgZone],{color:[0,'color'],mode:[1,'mode']},
          (null as any)),i1.ɵdid(16384,(null as any),0,i2.MdProgressSpinnerCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    ']))],(_ck,_v) => {
    const currVal_0:any = 'busy-overlay';
    _ck(_v,1,0,currVal_0);
    const currVal_5:any = 'white';
    const currVal_6:any = 'indeterminate';
    _ck(_v,4,0,currVal_5,currVal_6);
    const currVal_7:any = 'busy-spinner';
    _ck(_v,6,0,currVal_7);
  },(_ck,_v) => {
    const currVal_1:any = i1.ɵnov(_v,4)._ariaValueMin;
    const currVal_2:any = i1.ɵnov(_v,4)._ariaValueMax;
    const currVal_3:any = i1.ɵnov(_v,4).value;
    const currVal_4:any = i1.ɵnov(_v,4).mode;
    _ck(_v,3,0,currVal_1,currVal_2,currVal_3,currVal_4);
  });
}
export function View_VersionEditComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i8.DatePipe,[i1.LOCALE_ID]),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Edit a Version'])),
      (_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          274,'form',[['class','version-form'],['novalidate',''],['style','max-width: 500px;']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'submit'],[(null as any),'reset']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('submit' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,6).onSubmit($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,6).onReset()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.ɵbf,([] as any[]),
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i7.NgForm,[[8,
          (null as any)],[8,(null as any)]],(null as any),(null as any)),i1.ɵprd(2048,
          (null as any),i7.ControlContainer,(null as any),[i7.NgForm]),i1.ɵdid(16384,
          (null as any),0,i7.NgControlStatusGroup,[i7.ControlContainer],(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i6.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['Version Properties'])),(_l()(),i1.ɵted((null as any),
          ['\n\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_VersionEditComponent_1)),i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),24,'div',
          [['mdTooltip','Friendly name of the version (ex. 1, 16)'],['mdTooltipPosition',
              'after']],(null as any),[[(null as any),'longpress'],[(null as any),
              'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,19).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,19).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'md-input-container',
          [['class','version-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,22)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          7,{_mdInputChild:0}),i1.ɵqud(335544320,8,{_placeholderChild:0}),i1.ɵqud(603979776,
          9,{_errorChildren:1}),i1.ɵqud(603979776,10,{_hintChildren:1}),i1.ɵqud(603979776,
          11,{_prefixChildren:1}),i1.ɵqud(603979776,12,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,8,'input',[['class','mat-input-element'],['id','VersionName'],
              ['mdInput',''],['name','VersionName'],['placeholder','Version Name'],
              ['required',''],['value','VersionName']],[[1,'required',0],[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)],[8,'id',0],[8,'placeholder',
                  0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',0],[1,
                  'aria-invalid',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,32)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,32).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,32)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,32)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,39)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,39)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,39)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.version.VersionName = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i7.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i7.RequiredValidator]),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,
          i7.ControlContainer],[2,i7.NG_VALIDATORS],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),
          0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[7,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,[2,
              i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {id:[0,'id'],placeholder:[1,'placeholder'],required:[2,'required']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),25,'div',[['mdTooltip','Version number for sorting what is \'newer\'. (ex. \'1.2.3\', \'2\', \'444.3.123\')'],
              ['mdTooltipPosition','after']],(null as any),[[(null as any),'longpress'],
              [(null as any),'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,45).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,45).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),20,'md-input-container',
          [['class','version-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,48)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          13,{_mdInputChild:0}),i1.ɵqud(335544320,14,{_placeholderChild:0}),i1.ɵqud(603979776,
          15,{_errorChildren:1}),i1.ɵqud(603979776,16,{_hintChildren:1}),i1.ɵqud(603979776,
          17,{_prefixChildren:1}),i1.ɵqud(603979776,18,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,9,'input',[['class','mat-input-element'],['id','VersionNumber'],
              ['mdInput',''],['name','VersionNumber'],['pattern','^((\\d*)[.])*\\d*$'],
              ['placeholder','Version Number'],['required',''],['value','VersionNumber']],
          [[1,'required',0],[1,'pattern',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,58)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,58).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,58)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,58)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,66)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,66)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,66)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.version.VersionNumber = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i7.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵdid(540672,(null as any),0,
          i7.PatternValidator,([] as any[]),{pattern:[0,'pattern']},(null as any)),
      i1.ɵprd(1024,(null as any),i7.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
        return [p0_0,p1_0];
      },[i7.RequiredValidator,i7.PatternValidator]),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,
          i7.ControlContainer],[2,i7.NG_VALIDATORS],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),
          0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[13,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,[2,
              i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {id:[0,'id'],placeholder:[1,'placeholder'],required:[2,'required']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),23,'div',[['mdTooltip',''],['mdTooltipPosition','after']],
          (null as any),[[(null as any),'longpress'],[(null as any),'touchend']],(_v,
              en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,72).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,72).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['class','version-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,75)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          19,{_mdInputChild:0}),i1.ɵqud(335544320,20,{_placeholderChild:0}),i1.ɵqud(603979776,
          21,{_errorChildren:1}),i1.ɵqud(603979776,22,{_hintChildren:1}),i1.ɵqud(603979776,
          23,{_prefixChildren:1}),i1.ɵqud(603979776,24,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'textarea',[['class','mat-input-element'],['id','ReleaseNotes'],
              ['mdInput',''],['name','ReleaseNotes'],['placeholder','Release Notes'],
              ['value','ReleaseNotes']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,85)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,85).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,85)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,85)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,90)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,90)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,90)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.version.ReleaseNotes = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),0,i7.NgControlStatus,
          [i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[19,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,i3.Platform,[2,i7.NgControl],[2,i7.NgForm],[2,
              i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],{id:[0,'id'],
              placeholder:[1,'placeholder']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['            '])),(_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(16777216,
          (null as any),(null as any),23,'div',[['mdTooltip',''],['mdTooltipPosition',
              'after']],(null as any),[[(null as any),'longpress'],[(null as any),
              'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,97).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,97).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['class','version-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,100)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          25,{_mdInputChild:0}),i1.ɵqud(335544320,26,{_placeholderChild:0}),i1.ɵqud(603979776,
          27,{_errorChildren:1}),i1.ɵqud(603979776,28,{_hintChildren:1}),i1.ɵqud(603979776,
          29,{_prefixChildren:1}),i1.ɵqud(603979776,30,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'textarea',[['class','mat-input-element'],['id','EngrNotes'],
              ['mdInput',''],['name','EngrNotes'],['placeholder','Engineering Notes'],
              ['value','EngrNotes']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,110)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,110).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,110)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,110)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,115)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,115)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,115)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.version.EngrNotes = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),0,i7.NgControlStatus,
          [i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[25,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,i3.Platform,[2,i7.NgControl],[2,i7.NgForm],[2,
              i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],{id:[0,'id'],
              placeholder:[1,'placeholder']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['            '])),(_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(16777216,
          (null as any),(null as any),23,'div',[['mdTooltip',''],['mdTooltipPosition',
              'after']],(null as any),[[(null as any),'longpress'],[(null as any),
              'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,122).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,122).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',
          [['class','version-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,125)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          31,{_mdInputChild:0}),i1.ɵqud(335544320,32,{_placeholderChild:0}),i1.ɵqud(603979776,
          33,{_errorChildren:1}),i1.ɵqud(603979776,34,{_hintChildren:1}),i1.ɵqud(603979776,
          35,{_prefixChildren:1}),i1.ɵqud(603979776,36,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['class','mat-input-element'],['mdInput',''],
              ['name','ReleaseDate'],['placeholder','Release Date'],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[8,'id',
                  0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',
                  0],[1,'aria-invalid',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,135)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,135).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,135)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,135)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,141)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,141)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,141)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.version.ReleaseDate = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i1.ɵppd(2),i1.ɵprd(2048,(null as any),
          i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,(null as any),0,i7.NgControlStatus,
          [i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[31,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,i3.Platform,[2,i7.NgControl],[2,i7.NgForm],[2,
              i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],{placeholder:[0,
              'placeholder'],type:[1,'type']},(null as any)),(_l()(),i1.ɵted(1,['\n        '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵeld(16777216,(null as any),(null as any),17,'div',[['mdTooltip',
          'Version release status'],['mdTooltipPosition','after']],(null as any),[[(null as any),
          'longpress'],[(null as any),'touchend']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('longpress' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,147).show()) !== false);
          ad = (pd_0 && ad);
        }
        if (('touchend' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,147).hide(1500)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'md-select',
          [['class','version-full-width mat-select'],['name','Status'],['placeholder',
              'Release Status'],['role','listbox']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,
                  'aria-labelledby',0],[1,'aria-required',0],[1,'aria-disabled',0],
              [1,'aria-invalid',0],[1,'aria-owns',0],[2,'mat-select-disabled',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'keydown'],[(null as any),
              'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,154)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,154)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.version.Status = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i4.View_MdSelect_0,i4.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i7.NgModel,[[2,i7.ControlContainer],[8,(null as any)],[8,(null as any)],
              [8,(null as any)]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,
          (null as any),0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          2,i2.MdSelect,[i2.ViewportRuler,i1.ChangeDetectorRef,i1.Renderer2,i1.ElementRef,
              [2,i3.Directionality],[2,i7.NgControl],[8,(null as any)],[2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵqud(603979776,37,{options:1}),
      i1.ɵqud(603979776,38,{optionGroups:1}),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),
          View_VersionEditComponent_2)),i1.ɵdid(802816,(null as any),0,i8.NgForOf,
          [i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},
          (null as any)),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),1,'h4',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['File Upload'])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),1,'input',[['accept','.*'],['class','version-upload'],
              ['placeholder','Upload'],['type','file']],(null as any),[[(null as any),
              'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>_co.fileUpload($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),22,'div',
          [['mdTooltip',''],['mdTooltipPosition','after']],(null as any),[[(null as any),
              'longpress'],[(null as any),'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,172).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,172).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'md-input-container',
          [['class','version-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,175)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          39,{_mdInputChild:0}),i1.ɵqud(335544320,40,{_placeholderChild:0}),i1.ɵqud(603979776,
          41,{_errorChildren:1}),i1.ɵqud(603979776,42,{_hintChildren:1}),i1.ɵqud(603979776,
          43,{_prefixChildren:1}),i1.ɵqud(603979776,44,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,6,'input',[['class','mat-input-element'],['disabled',''],
              ['id','Url'],['mdInput',''],['name','Url'],['placeholder','File URL'],
              ['value','Url']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,185)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,185).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,185)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,185)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,190)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,190)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,190)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.version.Url = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          isDisabled:[1,'isDisabled'],model:[2,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,
          (null as any),0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,[[39,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,
          [2,i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {disabled:[0,'disabled'],id:[1,'id'],placeholder:[2,'placeholder']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),22,'div',[['mdTooltip',''],['mdTooltipPosition','after']],
          (null as any),[[(null as any),'longpress'],[(null as any),'touchend']],(_v,
              en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,196).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,196).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(147456,(null as any),0,i2.MdTooltip,[i2.Overlay,i1.ElementRef,i2.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i3.Platform,[2,i3.Directionality]],
          {position:[0,'position'],message:[1,'message']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'md-input-container',
          [['class','version-full-width mat-input-container']],[[1,'align',0],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,199)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          45,{_mdInputChild:0}),i1.ɵqud(335544320,46,{_placeholderChild:0}),i1.ɵqud(603979776,
          47,{_errorChildren:1}),i1.ɵqud(603979776,48,{_hintChildren:1}),i1.ɵqud(603979776,
          49,{_prefixChildren:1}),i1.ɵqud(603979776,50,{_suffixChildren:1}),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,6,'input',[['class','mat-input-element'],['disabled',''],
              ['id','Hash'],['mdInput',''],['name','Hash'],['placeholder','File Hash'],
              ['value','Hash']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,209)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,209).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,209)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,209)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,214)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,214)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,214)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.version.Hash = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i7.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i7.NgModel,[[2,i7.ControlContainer],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          isDisabled:[1,'isDisabled'],model:[2,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i7.NgControl,(null as any),[i7.NgModel]),i1.ɵdid(16384,
          (null as any),0,i7.NgControlStatus,[i7.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,[[45,4]],0,i2.MdInputDirective,[i1.ElementRef,i1.Renderer2,i3.Platform,
          [2,i7.NgControl],[2,i7.NgForm],[2,i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],
          {disabled:[0,'disabled'],id:[1,'id'],placeholder:[2,'placeholder']},(null as any)),
      (_l()(),i1.ɵted(1,['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'h4',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Products'])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          17,'md-input-container',[['class','mat-input-container']],[[1,'align',0],
              [2,'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],
              [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
                  (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,222)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdInputContainer_0,i4.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i2.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),i1.ɵqud(335544320,
          51,{_mdInputChild:0}),i1.ɵqud(335544320,52,{_placeholderChild:0}),i1.ɵqud(603979776,
          53,{_errorChildren:1}),i1.ɵqud(603979776,54,{_hintChildren:1}),i1.ɵqud(603979776,
          55,{_prefixChildren:1}),i1.ɵqud(603979776,56,{_suffixChildren:1}),(_l()(),
          i1.ɵted(1,['\n        '])),(_l()(),i1.ɵeld(16777216,(null as any),1,7,'input',
          [['aria-autocomplete','list'],['aria-multiline','false'],['autocomplete',
              'off'],['class','mat-input-element'],['mdInput',''],['placeholder','Linked Products'],
              ['role','combobox']],[[1,'aria-activedescendant',0],[1,'aria-expanded',
              0],[1,'aria-owns',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0]],[[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focusin'],[(null as any),'keydown'],
              [(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,231)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,231).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,231)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,231)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('focusin' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,232).openPanel()) !== false);
              ad = (pd_4 && ad);
            }
            if (('input' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,232)._handleInput($event)) !== false);
              ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,232)._onTouched()) !== false);
              ad = (pd_6 && ad);
            }
            if (('keydown' === en)) {
              const pd_7:any = ((<any>i1.ɵnov(_v,232)._handleKeydown($event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('blur' === en)) {
              const pd_8:any = ((<any>i1.ɵnov(_v,237)._onBlur()) !== false);
              ad = (pd_8 && ad);
            }
            if (('focus' === en)) {
              const pd_9:any = ((<any>i1.ɵnov(_v,237)._onFocus()) !== false);
              ad = (pd_9 && ad);
            }
            if (('input' === en)) {
              const pd_10:any = ((<any>i1.ɵnov(_v,237)._onInput()) !== false);
              ad = (pd_10 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i7.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(147456,(null as any),0,i2.MdAutocompleteTrigger,[i1.ElementRef,
          i2.Overlay,i1.ViewContainerRef,i1.NgZone,i1.ChangeDetectorRef,[2,i3.Directionality],
          [2,i2.MdInputContainer],[2,i10.DOCUMENT]],{autocomplete:[0,'autocomplete']},
          (null as any)),i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any,
          p1_0:any) => {
        return [p0_0,p1_0];
      },[i7.DefaultValueAccessor,i2.MdAutocompleteTrigger]),i1.ɵdid(540672,(null as any),
          0,i7.FormControlDirective,[[8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],
          {form:[0,'form']},(null as any)),i1.ɵprd(2048,(null as any),i7.NgControl,
          (null as any),[i7.FormControlDirective]),i1.ɵdid(16384,(null as any),0,i7.NgControlStatus,
          [i7.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[51,4]],0,i2.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,i3.Platform,[2,i7.NgControl],[2,i7.NgForm],[2,
              i7.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],{placeholder:[0,
              'placeholder']},(null as any)),(_l()(),i1.ɵted(1,['\n    '])),(_l()(),
          i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          8,'md-autocomplete',[['class','mat-autocomplete']],(null as any),(null as any),
          (null as any),i4.View_MdAutocomplete_0,i4.RenderType_MdAutocomplete)),i1.ɵdid(16384,
          (null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1097728,[['auto',
          4]],1,i2.MdAutocomplete,[i1.ChangeDetectorRef],(null as any),(null as any)),
      i1.ɵqud(603979776,57,{options:1}),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,2,(null as any),View_VersionEditComponent_3)),
      i1.ɵdid(802816,(null as any),0,i8.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,
          i8.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),
          i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          7,'md-chip-list',[['class','version-full-width mat-chip-list'],['role','listbox']],
          [[1,'tabindex',0]],[[(null as any),'focus'],[(null as any),'keydown']],(_v,
              en,$event) => {
            var ad:boolean = true;
            if (('focus' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,251).focus()) !== false);
              ad = (pd_0 && ad);
            }
            if (('keydown' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,251)._keydown($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_MdChipList_0,i4.RenderType_MdChipList)),i1.ɵdid(1228800,[['chipList',
          4]],1,i2.MdChipList,([] as any[]),(null as any),(null as any)),i1.ɵqud(603979776,
          58,{chips:1}),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i6.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,['\n        '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_VersionEditComponent_4)),
      i1.ɵdid(802816,(null as any),0,i8.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),15,'div',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'button',
          [['class','version-button mat-raised-button'],['color','primary'],['md-raised-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.saveVersion(_co.version,_co.selectedProducts)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdButton_0,i4.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i2.MdButton,
          [i1.Renderer2,i1.ElementRef,i3.Platform,i2.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i2.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['Save'])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'button',
          [['class','version-button mat-raised-button'],['md-raised-button','']],[[8,
              'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i9.VersionEditComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.cancel()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdButton_0,i4.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i2.MdButton,
          [i1.Renderer2,i1.ElementRef,i3.Platform,i2.FocusOriginMonitor],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i2.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['Cancel'])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_VersionEditComponent_5)),
      i1.ɵdid(16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),
          i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i9.VersionEditComponent = _v.component;
    const currVal_7:any = 'version-form';
    _ck(_v,9,0,currVal_7);
    const currVal_8:any = (_co.version.Id > 0);
    _ck(_v,15,0,currVal_8);
    const currVal_9:any = 'after';
    const currVal_10:any = 'Friendly name of the version (ex. 1, 16)';
    _ck(_v,19,0,currVal_9,currVal_10);
    const currVal_21:any = 'version-full-width';
    _ck(_v,29,0,currVal_21);
    const currVal_36:any = '';
    _ck(_v,33,0,currVal_36);
    const currVal_37:any = 'VersionName';
    const currVal_38:any = _co.version.VersionName;
    _ck(_v,36,0,currVal_37,currVal_38);
    const currVal_39:any = 'VersionName';
    const currVal_40:any = 'Version Name';
    const currVal_41:any = '';
    _ck(_v,39,0,currVal_39,currVal_40,currVal_41);
    const currVal_42:any = 'after';
    const currVal_43:any = 'Version number for sorting what is \'newer\'. (ex. \'1.2.3\', \'2\', \'444.3.123\')';
    _ck(_v,45,0,currVal_42,currVal_43);
    const currVal_54:any = 'version-full-width';
    _ck(_v,55,0,currVal_54);
    const currVal_70:any = '';
    _ck(_v,59,0,currVal_70);
    const currVal_71:any = '^((\\d*)[.])*\\d*$';
    _ck(_v,60,0,currVal_71);
    const currVal_72:any = 'VersionNumber';
    const currVal_73:any = _co.version.VersionNumber;
    _ck(_v,63,0,currVal_72,currVal_73);
    const currVal_74:any = 'VersionNumber';
    const currVal_75:any = 'Version Number';
    const currVal_76:any = '';
    _ck(_v,66,0,currVal_74,currVal_75,currVal_76);
    const currVal_77:any = 'after';
    const currVal_78:any = '';
    _ck(_v,72,0,currVal_77,currVal_78);
    const currVal_89:any = 'version-full-width';
    _ck(_v,82,0,currVal_89);
    const currVal_103:any = 'ReleaseNotes';
    const currVal_104:any = _co.version.ReleaseNotes;
    _ck(_v,87,0,currVal_103,currVal_104);
    const currVal_105:any = 'ReleaseNotes';
    const currVal_106:any = 'Release Notes';
    _ck(_v,90,0,currVal_105,currVal_106);
    const currVal_107:any = 'after';
    const currVal_108:any = '';
    _ck(_v,97,0,currVal_107,currVal_108);
    const currVal_119:any = 'version-full-width';
    _ck(_v,107,0,currVal_119);
    const currVal_133:any = 'EngrNotes';
    const currVal_134:any = _co.version.EngrNotes;
    _ck(_v,112,0,currVal_133,currVal_134);
    const currVal_135:any = 'EngrNotes';
    const currVal_136:any = 'Engineering Notes';
    _ck(_v,115,0,currVal_135,currVal_136);
    const currVal_137:any = 'after';
    const currVal_138:any = '';
    _ck(_v,122,0,currVal_137,currVal_138);
    const currVal_149:any = 'version-full-width';
    _ck(_v,132,0,currVal_149);
    const currVal_163:any = 'ReleaseDate';
    const currVal_164:any = i1.ɵunv(_v,137,1,_ck(_v,138,0,i1.ɵnov(_v,0),_co.version.ReleaseDate,
        'yyyy-MM-dd'));
    _ck(_v,137,0,currVal_163,currVal_164);
    const currVal_165:any = 'Release Date';
    const currVal_166:any = 'date';
    _ck(_v,141,0,currVal_165,currVal_166);
    const currVal_167:any = 'after';
    const currVal_168:any = 'Version release status';
    _ck(_v,147,0,currVal_167,currVal_168);
    const currVal_184:any = 'Status';
    const currVal_185:any = _co.version.Status;
    _ck(_v,150,0,currVal_184,currVal_185);
    const currVal_186:any = 'Release Status';
    _ck(_v,154,0,currVal_186);
    const currVal_187:any = 'version-full-width';
    _ck(_v,157,0,currVal_187);
    const currVal_188:any = _co.releaseStatus;
    _ck(_v,160,0,currVal_188);
    const currVal_189:any = 'version-upload';
    _ck(_v,168,0,currVal_189);
    const currVal_190:any = 'after';
    const currVal_191:any = '';
    _ck(_v,172,0,currVal_190,currVal_191);
    const currVal_202:any = 'version-full-width';
    _ck(_v,182,0,currVal_202);
    const currVal_216:any = 'Url';
    const currVal_217:any = '';
    const currVal_218:any = _co.version.Url;
    _ck(_v,187,0,currVal_216,currVal_217,currVal_218);
    const currVal_219:any = '';
    const currVal_220:any = 'Url';
    const currVal_221:any = 'File URL';
    _ck(_v,190,0,currVal_219,currVal_220,currVal_221);
    const currVal_222:any = 'after';
    const currVal_223:any = '';
    _ck(_v,196,0,currVal_222,currVal_223);
    const currVal_234:any = 'version-full-width';
    _ck(_v,206,0,currVal_234);
    const currVal_248:any = 'Hash';
    const currVal_249:any = '';
    const currVal_250:any = _co.version.Hash;
    _ck(_v,211,0,currVal_248,currVal_249,currVal_250);
    const currVal_251:any = '';
    const currVal_252:any = 'Hash';
    const currVal_253:any = 'File Hash';
    _ck(_v,214,0,currVal_251,currVal_252,currVal_253);
    const currVal_280:any = i1.ɵnov(_v,242);
    _ck(_v,232,0,currVal_280);
    const currVal_281:any = _co.productCtrl;
    _ck(_v,234,0,currVal_281);
    const currVal_282:any = 'Linked Products';
    _ck(_v,237,0,currVal_282);
    const currVal_283:any = i1.ɵunv(_v,246,0,i1.ɵnov(_v,247).transform(_co.filteredProducts));
    _ck(_v,246,0,currVal_283);
    const currVal_285:any = 'version-full-width';
    _ck(_v,253,0,currVal_285);
    const currVal_286:any = _co.selectedProducts;
    _ck(_v,256,0,currVal_286);
    const currVal_288:any = 'primary';
    _ck(_v,263,0,currVal_288);
    const currVal_289:any = 'version-button';
    _ck(_v,265,0,currVal_289);
    const currVal_291:any = 'version-button';
    _ck(_v,272,0,currVal_291);
    const currVal_292:any = _co.busy;
    _ck(_v,277,0,currVal_292);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,8).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,8).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,8).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,8).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,8).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,8).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,8).ngClassPending;
    _ck(_v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_11:any = (null as any);
    const currVal_12:any = i1.ɵnov(_v,22)._mdInputChild._isErrorState();
    const currVal_13:any = i1.ɵnov(_v,22)._mdInputChild.focused;
    const currVal_14:any = i1.ɵnov(_v,22)._shouldForward('untouched');
    const currVal_15:any = i1.ɵnov(_v,22)._shouldForward('touched');
    const currVal_16:any = i1.ɵnov(_v,22)._shouldForward('pristine');
    const currVal_17:any = i1.ɵnov(_v,22)._shouldForward('dirty');
    const currVal_18:any = i1.ɵnov(_v,22)._shouldForward('valid');
    const currVal_19:any = i1.ɵnov(_v,22)._shouldForward('invalid');
    const currVal_20:any = i1.ɵnov(_v,22)._shouldForward('pending');
    _ck(_v,21,0,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
        currVal_17,currVal_18,currVal_19,currVal_20);
    const currVal_22:any = (i1.ɵnov(_v,33).required? '': (null as any));
    const currVal_23:any = i1.ɵnov(_v,38).ngClassUntouched;
    const currVal_24:any = i1.ɵnov(_v,38).ngClassTouched;
    const currVal_25:any = i1.ɵnov(_v,38).ngClassPristine;
    const currVal_26:any = i1.ɵnov(_v,38).ngClassDirty;
    const currVal_27:any = i1.ɵnov(_v,38).ngClassValid;
    const currVal_28:any = i1.ɵnov(_v,38).ngClassInvalid;
    const currVal_29:any = i1.ɵnov(_v,38).ngClassPending;
    const currVal_30:any = i1.ɵnov(_v,39).id;
    const currVal_31:any = i1.ɵnov(_v,39).placeholder;
    const currVal_32:any = i1.ɵnov(_v,39).disabled;
    const currVal_33:any = i1.ɵnov(_v,39).required;
    const currVal_34:any = (i1.ɵnov(_v,39).ariaDescribedby || (null as any));
    const currVal_35:any = i1.ɵnov(_v,39)._isErrorState();
    _ck(_v,31,1,[currVal_22,currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,
        currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33,currVal_34,
        currVal_35]);
    const currVal_44:any = (null as any);
    const currVal_45:any = i1.ɵnov(_v,48)._mdInputChild._isErrorState();
    const currVal_46:any = i1.ɵnov(_v,48)._mdInputChild.focused;
    const currVal_47:any = i1.ɵnov(_v,48)._shouldForward('untouched');
    const currVal_48:any = i1.ɵnov(_v,48)._shouldForward('touched');
    const currVal_49:any = i1.ɵnov(_v,48)._shouldForward('pristine');
    const currVal_50:any = i1.ɵnov(_v,48)._shouldForward('dirty');
    const currVal_51:any = i1.ɵnov(_v,48)._shouldForward('valid');
    const currVal_52:any = i1.ɵnov(_v,48)._shouldForward('invalid');
    const currVal_53:any = i1.ɵnov(_v,48)._shouldForward('pending');
    _ck(_v,47,0,currVal_44,currVal_45,currVal_46,currVal_47,currVal_48,currVal_49,
        currVal_50,currVal_51,currVal_52,currVal_53);
    const currVal_55:any = (i1.ɵnov(_v,59).required? '': (null as any));
    const currVal_56:any = (i1.ɵnov(_v,60).pattern? i1.ɵnov(_v,60).pattern: (null as any));
    const currVal_57:any = i1.ɵnov(_v,65).ngClassUntouched;
    const currVal_58:any = i1.ɵnov(_v,65).ngClassTouched;
    const currVal_59:any = i1.ɵnov(_v,65).ngClassPristine;
    const currVal_60:any = i1.ɵnov(_v,65).ngClassDirty;
    const currVal_61:any = i1.ɵnov(_v,65).ngClassValid;
    const currVal_62:any = i1.ɵnov(_v,65).ngClassInvalid;
    const currVal_63:any = i1.ɵnov(_v,65).ngClassPending;
    const currVal_64:any = i1.ɵnov(_v,66).id;
    const currVal_65:any = i1.ɵnov(_v,66).placeholder;
    const currVal_66:any = i1.ɵnov(_v,66).disabled;
    const currVal_67:any = i1.ɵnov(_v,66).required;
    const currVal_68:any = (i1.ɵnov(_v,66).ariaDescribedby || (null as any));
    const currVal_69:any = i1.ɵnov(_v,66)._isErrorState();
    _ck(_v,57,1,[currVal_55,currVal_56,currVal_57,currVal_58,currVal_59,currVal_60,
        currVal_61,currVal_62,currVal_63,currVal_64,currVal_65,currVal_66,currVal_67,
        currVal_68,currVal_69]);
    const currVal_79:any = (null as any);
    const currVal_80:any = i1.ɵnov(_v,75)._mdInputChild._isErrorState();
    const currVal_81:any = i1.ɵnov(_v,75)._mdInputChild.focused;
    const currVal_82:any = i1.ɵnov(_v,75)._shouldForward('untouched');
    const currVal_83:any = i1.ɵnov(_v,75)._shouldForward('touched');
    const currVal_84:any = i1.ɵnov(_v,75)._shouldForward('pristine');
    const currVal_85:any = i1.ɵnov(_v,75)._shouldForward('dirty');
    const currVal_86:any = i1.ɵnov(_v,75)._shouldForward('valid');
    const currVal_87:any = i1.ɵnov(_v,75)._shouldForward('invalid');
    const currVal_88:any = i1.ɵnov(_v,75)._shouldForward('pending');
    _ck(_v,74,0,currVal_79,currVal_80,currVal_81,currVal_82,currVal_83,currVal_84,
        currVal_85,currVal_86,currVal_87,currVal_88);
    const currVal_90:any = i1.ɵnov(_v,89).ngClassUntouched;
    const currVal_91:any = i1.ɵnov(_v,89).ngClassTouched;
    const currVal_92:any = i1.ɵnov(_v,89).ngClassPristine;
    const currVal_93:any = i1.ɵnov(_v,89).ngClassDirty;
    const currVal_94:any = i1.ɵnov(_v,89).ngClassValid;
    const currVal_95:any = i1.ɵnov(_v,89).ngClassInvalid;
    const currVal_96:any = i1.ɵnov(_v,89).ngClassPending;
    const currVal_97:any = i1.ɵnov(_v,90).id;
    const currVal_98:any = i1.ɵnov(_v,90).placeholder;
    const currVal_99:any = i1.ɵnov(_v,90).disabled;
    const currVal_100:any = i1.ɵnov(_v,90).required;
    const currVal_101:any = (i1.ɵnov(_v,90).ariaDescribedby || (null as any));
    const currVal_102:any = i1.ɵnov(_v,90)._isErrorState();
    _ck(_v,84,1,[currVal_90,currVal_91,currVal_92,currVal_93,currVal_94,currVal_95,
        currVal_96,currVal_97,currVal_98,currVal_99,currVal_100,currVal_101,currVal_102]);
    const currVal_109:any = (null as any);
    const currVal_110:any = i1.ɵnov(_v,100)._mdInputChild._isErrorState();
    const currVal_111:any = i1.ɵnov(_v,100)._mdInputChild.focused;
    const currVal_112:any = i1.ɵnov(_v,100)._shouldForward('untouched');
    const currVal_113:any = i1.ɵnov(_v,100)._shouldForward('touched');
    const currVal_114:any = i1.ɵnov(_v,100)._shouldForward('pristine');
    const currVal_115:any = i1.ɵnov(_v,100)._shouldForward('dirty');
    const currVal_116:any = i1.ɵnov(_v,100)._shouldForward('valid');
    const currVal_117:any = i1.ɵnov(_v,100)._shouldForward('invalid');
    const currVal_118:any = i1.ɵnov(_v,100)._shouldForward('pending');
    _ck(_v,99,0,currVal_109,currVal_110,currVal_111,currVal_112,currVal_113,currVal_114,
        currVal_115,currVal_116,currVal_117,currVal_118);
    const currVal_120:any = i1.ɵnov(_v,114).ngClassUntouched;
    const currVal_121:any = i1.ɵnov(_v,114).ngClassTouched;
    const currVal_122:any = i1.ɵnov(_v,114).ngClassPristine;
    const currVal_123:any = i1.ɵnov(_v,114).ngClassDirty;
    const currVal_124:any = i1.ɵnov(_v,114).ngClassValid;
    const currVal_125:any = i1.ɵnov(_v,114).ngClassInvalid;
    const currVal_126:any = i1.ɵnov(_v,114).ngClassPending;
    const currVal_127:any = i1.ɵnov(_v,115).id;
    const currVal_128:any = i1.ɵnov(_v,115).placeholder;
    const currVal_129:any = i1.ɵnov(_v,115).disabled;
    const currVal_130:any = i1.ɵnov(_v,115).required;
    const currVal_131:any = (i1.ɵnov(_v,115).ariaDescribedby || (null as any));
    const currVal_132:any = i1.ɵnov(_v,115)._isErrorState();
    _ck(_v,109,1,[currVal_120,currVal_121,currVal_122,currVal_123,currVal_124,currVal_125,
        currVal_126,currVal_127,currVal_128,currVal_129,currVal_130,currVal_131,currVal_132]);
    const currVal_139:any = (null as any);
    const currVal_140:any = i1.ɵnov(_v,125)._mdInputChild._isErrorState();
    const currVal_141:any = i1.ɵnov(_v,125)._mdInputChild.focused;
    const currVal_142:any = i1.ɵnov(_v,125)._shouldForward('untouched');
    const currVal_143:any = i1.ɵnov(_v,125)._shouldForward('touched');
    const currVal_144:any = i1.ɵnov(_v,125)._shouldForward('pristine');
    const currVal_145:any = i1.ɵnov(_v,125)._shouldForward('dirty');
    const currVal_146:any = i1.ɵnov(_v,125)._shouldForward('valid');
    const currVal_147:any = i1.ɵnov(_v,125)._shouldForward('invalid');
    const currVal_148:any = i1.ɵnov(_v,125)._shouldForward('pending');
    _ck(_v,124,0,currVal_139,currVal_140,currVal_141,currVal_142,currVal_143,currVal_144,
        currVal_145,currVal_146,currVal_147,currVal_148);
    const currVal_150:any = i1.ɵnov(_v,140).ngClassUntouched;
    const currVal_151:any = i1.ɵnov(_v,140).ngClassTouched;
    const currVal_152:any = i1.ɵnov(_v,140).ngClassPristine;
    const currVal_153:any = i1.ɵnov(_v,140).ngClassDirty;
    const currVal_154:any = i1.ɵnov(_v,140).ngClassValid;
    const currVal_155:any = i1.ɵnov(_v,140).ngClassInvalid;
    const currVal_156:any = i1.ɵnov(_v,140).ngClassPending;
    const currVal_157:any = i1.ɵnov(_v,141).id;
    const currVal_158:any = i1.ɵnov(_v,141).placeholder;
    const currVal_159:any = i1.ɵnov(_v,141).disabled;
    const currVal_160:any = i1.ɵnov(_v,141).required;
    const currVal_161:any = (i1.ɵnov(_v,141).ariaDescribedby || (null as any));
    const currVal_162:any = i1.ɵnov(_v,141)._isErrorState();
    _ck(_v,134,1,[currVal_150,currVal_151,currVal_152,currVal_153,currVal_154,currVal_155,
        currVal_156,currVal_157,currVal_158,currVal_159,currVal_160,currVal_161,currVal_162]);
    const currVal_169:any = i1.ɵnov(_v,152).ngClassUntouched;
    const currVal_170:any = i1.ɵnov(_v,152).ngClassTouched;
    const currVal_171:any = i1.ɵnov(_v,152).ngClassPristine;
    const currVal_172:any = i1.ɵnov(_v,152).ngClassDirty;
    const currVal_173:any = i1.ɵnov(_v,152).ngClassValid;
    const currVal_174:any = i1.ɵnov(_v,152).ngClassInvalid;
    const currVal_175:any = i1.ɵnov(_v,152).ngClassPending;
    const currVal_176:any = i1.ɵnov(_v,154).tabIndex;
    const currVal_177:any = i1.ɵnov(_v,154)._ariaLabel;
    const currVal_178:any = i1.ɵnov(_v,154).ariaLabelledby;
    const currVal_179:any = i1.ɵnov(_v,154).required.toString();
    const currVal_180:any = i1.ɵnov(_v,154).disabled.toString();
    const currVal_181:any = (((i1.ɵnov(_v,154)._control == null)? (null as any): i1.ɵnov(_v,
        154)._control.invalid) || 'false');
    const currVal_182:any = i1.ɵnov(_v,154)._optionIds;
    const currVal_183:any = i1.ɵnov(_v,154).disabled;
    _ck(_v,149,1,[currVal_169,currVal_170,currVal_171,currVal_172,currVal_173,currVal_174,
        currVal_175,currVal_176,currVal_177,currVal_178,currVal_179,currVal_180,currVal_181,
        currVal_182,currVal_183]);
    const currVal_192:any = (null as any);
    const currVal_193:any = i1.ɵnov(_v,175)._mdInputChild._isErrorState();
    const currVal_194:any = i1.ɵnov(_v,175)._mdInputChild.focused;
    const currVal_195:any = i1.ɵnov(_v,175)._shouldForward('untouched');
    const currVal_196:any = i1.ɵnov(_v,175)._shouldForward('touched');
    const currVal_197:any = i1.ɵnov(_v,175)._shouldForward('pristine');
    const currVal_198:any = i1.ɵnov(_v,175)._shouldForward('dirty');
    const currVal_199:any = i1.ɵnov(_v,175)._shouldForward('valid');
    const currVal_200:any = i1.ɵnov(_v,175)._shouldForward('invalid');
    const currVal_201:any = i1.ɵnov(_v,175)._shouldForward('pending');
    _ck(_v,174,0,currVal_192,currVal_193,currVal_194,currVal_195,currVal_196,currVal_197,
        currVal_198,currVal_199,currVal_200,currVal_201);
    const currVal_203:any = i1.ɵnov(_v,189).ngClassUntouched;
    const currVal_204:any = i1.ɵnov(_v,189).ngClassTouched;
    const currVal_205:any = i1.ɵnov(_v,189).ngClassPristine;
    const currVal_206:any = i1.ɵnov(_v,189).ngClassDirty;
    const currVal_207:any = i1.ɵnov(_v,189).ngClassValid;
    const currVal_208:any = i1.ɵnov(_v,189).ngClassInvalid;
    const currVal_209:any = i1.ɵnov(_v,189).ngClassPending;
    const currVal_210:any = i1.ɵnov(_v,190).id;
    const currVal_211:any = i1.ɵnov(_v,190).placeholder;
    const currVal_212:any = i1.ɵnov(_v,190).disabled;
    const currVal_213:any = i1.ɵnov(_v,190).required;
    const currVal_214:any = (i1.ɵnov(_v,190).ariaDescribedby || (null as any));
    const currVal_215:any = i1.ɵnov(_v,190)._isErrorState();
    _ck(_v,184,1,[currVal_203,currVal_204,currVal_205,currVal_206,currVal_207,currVal_208,
        currVal_209,currVal_210,currVal_211,currVal_212,currVal_213,currVal_214,currVal_215]);
    const currVal_224:any = (null as any);
    const currVal_225:any = i1.ɵnov(_v,199)._mdInputChild._isErrorState();
    const currVal_226:any = i1.ɵnov(_v,199)._mdInputChild.focused;
    const currVal_227:any = i1.ɵnov(_v,199)._shouldForward('untouched');
    const currVal_228:any = i1.ɵnov(_v,199)._shouldForward('touched');
    const currVal_229:any = i1.ɵnov(_v,199)._shouldForward('pristine');
    const currVal_230:any = i1.ɵnov(_v,199)._shouldForward('dirty');
    const currVal_231:any = i1.ɵnov(_v,199)._shouldForward('valid');
    const currVal_232:any = i1.ɵnov(_v,199)._shouldForward('invalid');
    const currVal_233:any = i1.ɵnov(_v,199)._shouldForward('pending');
    _ck(_v,198,0,currVal_224,currVal_225,currVal_226,currVal_227,currVal_228,currVal_229,
        currVal_230,currVal_231,currVal_232,currVal_233);
    const currVal_235:any = i1.ɵnov(_v,213).ngClassUntouched;
    const currVal_236:any = i1.ɵnov(_v,213).ngClassTouched;
    const currVal_237:any = i1.ɵnov(_v,213).ngClassPristine;
    const currVal_238:any = i1.ɵnov(_v,213).ngClassDirty;
    const currVal_239:any = i1.ɵnov(_v,213).ngClassValid;
    const currVal_240:any = i1.ɵnov(_v,213).ngClassInvalid;
    const currVal_241:any = i1.ɵnov(_v,213).ngClassPending;
    const currVal_242:any = i1.ɵnov(_v,214).id;
    const currVal_243:any = i1.ɵnov(_v,214).placeholder;
    const currVal_244:any = i1.ɵnov(_v,214).disabled;
    const currVal_245:any = i1.ɵnov(_v,214).required;
    const currVal_246:any = (i1.ɵnov(_v,214).ariaDescribedby || (null as any));
    const currVal_247:any = i1.ɵnov(_v,214)._isErrorState();
    _ck(_v,208,1,[currVal_235,currVal_236,currVal_237,currVal_238,currVal_239,currVal_240,
        currVal_241,currVal_242,currVal_243,currVal_244,currVal_245,currVal_246,currVal_247]);
    const currVal_254:any = (null as any);
    const currVal_255:any = i1.ɵnov(_v,222)._mdInputChild._isErrorState();
    const currVal_256:any = i1.ɵnov(_v,222)._mdInputChild.focused;
    const currVal_257:any = i1.ɵnov(_v,222)._shouldForward('untouched');
    const currVal_258:any = i1.ɵnov(_v,222)._shouldForward('touched');
    const currVal_259:any = i1.ɵnov(_v,222)._shouldForward('pristine');
    const currVal_260:any = i1.ɵnov(_v,222)._shouldForward('dirty');
    const currVal_261:any = i1.ɵnov(_v,222)._shouldForward('valid');
    const currVal_262:any = i1.ɵnov(_v,222)._shouldForward('invalid');
    const currVal_263:any = i1.ɵnov(_v,222)._shouldForward('pending');
    _ck(_v,221,0,currVal_254,currVal_255,currVal_256,currVal_257,currVal_258,currVal_259,
        currVal_260,currVal_261,currVal_262,currVal_263);
    const currVal_264:any = ((i1.ɵnov(_v,232).activeOption == null)? (null as any): i1.ɵnov(_v,
        232).activeOption.id);
    const currVal_265:any = i1.ɵnov(_v,232).panelOpen.toString();
    const currVal_266:any = ((i1.ɵnov(_v,232).autocomplete == null)? (null as any): i1.ɵnov(_v,
        232).autocomplete.id);
    const currVal_267:any = i1.ɵnov(_v,236).ngClassUntouched;
    const currVal_268:any = i1.ɵnov(_v,236).ngClassTouched;
    const currVal_269:any = i1.ɵnov(_v,236).ngClassPristine;
    const currVal_270:any = i1.ɵnov(_v,236).ngClassDirty;
    const currVal_271:any = i1.ɵnov(_v,236).ngClassValid;
    const currVal_272:any = i1.ɵnov(_v,236).ngClassInvalid;
    const currVal_273:any = i1.ɵnov(_v,236).ngClassPending;
    const currVal_274:any = i1.ɵnov(_v,237).id;
    const currVal_275:any = i1.ɵnov(_v,237).placeholder;
    const currVal_276:any = i1.ɵnov(_v,237).disabled;
    const currVal_277:any = i1.ɵnov(_v,237).required;
    const currVal_278:any = (i1.ɵnov(_v,237).ariaDescribedby || (null as any));
    const currVal_279:any = i1.ɵnov(_v,237)._isErrorState();
    _ck(_v,230,1,[currVal_264,currVal_265,currVal_266,currVal_267,currVal_268,currVal_269,
        currVal_270,currVal_271,currVal_272,currVal_273,currVal_274,currVal_275,currVal_276,
        currVal_277,currVal_278,currVal_279]);
    const currVal_284:any = i1.ɵnov(_v,251)._tabIndex;
    _ck(_v,250,0,currVal_284);
    const currVal_287:any = (i1.ɵnov(_v,263).disabled || (null as any));
    _ck(_v,261,0,currVal_287);
    const currVal_290:any = (i1.ɵnov(_v,270).disabled || (null as any));
    _ck(_v,268,0,currVal_290);
  });
}
export function View_VersionEditComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'versionedit',
      ([] as any[]),(null as any),(null as any),(null as any),View_VersionEditComponent_0,
      RenderType_VersionEditComponent)),i1.ɵprd(512,(null as any),i11.AuthService,
      i11.AuthService,[i12.Router,i13.ORIGIN_URL]),i1.ɵdid(49152,(null as any),0,i9.VersionEditComponent,
      [i14.SoftwareService,i11.AuthService,i2.MdSnackBar,i12.ActivatedRoute],(null as any),
      (null as any))],(null as any),(null as any));
}
export const VersionEditComponentNgFactory:i1.ComponentFactory<i9.VersionEditComponent> = i1.ɵccf('versionedit',
    i9.VersionEditComponent,View_VersionEditComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL0NsaWVudC9hcHAvY29udGFpbmVycy92ZXJzaW9uZWRpdC92ZXJzaW9uZWRpdC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL0NsaWVudC9hcHAvY29udGFpbmVycy92ZXJzaW9uZWRpdC92ZXJzaW9uZWRpdC5jb21wb25lbnQudHMiLCJuZzovLy9kOi9hLzEvcy9Tb2Z0d2FyZU1hbmFnZXIvQ2xpZW50L2FwcC9jb250YWluZXJzL3ZlcnNpb25lZGl0L3ZlcnNpb25lZGl0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL0NsaWVudC9hcHAvY29udGFpbmVycy92ZXJzaW9uZWRpdC92ZXJzaW9uZWRpdC5jb21wb25lbnQudHMuVmVyc2lvbkVkaXRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8aDI+RWRpdCBhIFZlcnNpb248L2gyPlxyXG48Zm9ybSBjbGFzcz1cInZlcnNpb24tZm9ybVwiIHN0eWxlPVwibWF4LXdpZHRoOiA1MDBweDtcIj5cclxuICAgIDxoMz5WZXJzaW9uIFByb3BlcnRpZXM8L2gzPlxyXG5cclxuICAgIDxkaXYgbWRUb29sdGlwPVwiVmVyc2lvbiBJRCBhc3NpZ25lZCBieSB0aGUgc3lzdGVtXCIgbWRUb29sdGlwUG9zaXRpb249XCJhZnRlclwiICpuZ0lmPVwidmVyc2lvbi5JZCA+IDBcIj5cclxuICAgICAgICA8bWQtaW5wdXQtY29udGFpbmVyIGNsYXNzPVwidmVyc2lvbi1mdWxsLXdpZHRoXCI+XHJcbiAgICAgICAgICAgIDxpbnB1dCBtZElucHV0IHBsYWNlaG9sZGVyPVwiVmVyc2lvbiBJZFwiIHZhbHVlPVwiSWRcIiBpZD1cIklkXCIgZGlzYWJsZWQgWyhuZ01vZGVsKV09XCJ2ZXJzaW9uLklkXCIgbmFtZT1cIklkXCIgLz5cclxuICAgICAgICA8L21kLWlucHV0LWNvbnRhaW5lcj5cclxuICAgIDwvZGl2PlxyXG4gICAgPGRpdiBtZFRvb2x0aXA9XCJGcmllbmRseSBuYW1lIG9mIHRoZSB2ZXJzaW9uIChleC4gMSwgMTYpXCIgbWRUb29sdGlwUG9zaXRpb249XCJhZnRlclwiPlxyXG4gICAgICAgIDxtZC1pbnB1dC1jb250YWluZXIgY2xhc3M9XCJ2ZXJzaW9uLWZ1bGwtd2lkdGhcIj5cclxuICAgICAgICAgICAgPGlucHV0IG1kSW5wdXQgcGxhY2Vob2xkZXI9XCJWZXJzaW9uIE5hbWVcIiB2YWx1ZT1cIlZlcnNpb25OYW1lXCIgaWQ9XCJWZXJzaW9uTmFtZVwiIHJlcXVpcmVkIFsobmdNb2RlbCldPVwidmVyc2lvbi5WZXJzaW9uTmFtZVwiIG5hbWU9XCJWZXJzaW9uTmFtZVwiIC8+XHJcbiAgICAgICAgPC9tZC1pbnB1dC1jb250YWluZXI+XHJcbiAgICA8L2Rpdj5cclxuICAgIDxkaXYgbWRUb29sdGlwPVwiVmVyc2lvbiBudW1iZXIgZm9yIHNvcnRpbmcgd2hhdCBpcyAnbmV3ZXInLiAoZXguICcxLjIuMycsICcyJywgJzQ0NC4zLjEyMycpXCIgbWRUb29sdGlwUG9zaXRpb249XCJhZnRlclwiPlxyXG4gICAgICAgIDxtZC1pbnB1dC1jb250YWluZXIgY2xhc3M9XCJ2ZXJzaW9uLWZ1bGwtd2lkdGhcIj5cclxuICAgICAgICAgICAgPGlucHV0IG1kSW5wdXQgcGxhY2Vob2xkZXI9XCJWZXJzaW9uIE51bWJlclwiIHZhbHVlPVwiVmVyc2lvbk51bWJlclwiIGlkPVwiVmVyc2lvbk51bWJlclwiIHJlcXVpcmVkIFsobmdNb2RlbCldPVwidmVyc2lvbi5WZXJzaW9uTnVtYmVyXCIgbmFtZT1cIlZlcnNpb25OdW1iZXJcIiBwYXR0ZXJuPVwiXigoXFxkKilbLl0pKlxcZCokXCIgLz5cclxuICAgICAgICA8L21kLWlucHV0LWNvbnRhaW5lcj5cclxuICAgIDwvZGl2PlxyXG5cclxuICAgIDxkaXYgbWRUb29sdGlwPVwiXCIgbWRUb29sdGlwUG9zaXRpb249XCJhZnRlclwiPlxyXG4gICAgICAgIDxtZC1pbnB1dC1jb250YWluZXIgY2xhc3M9XCJ2ZXJzaW9uLWZ1bGwtd2lkdGhcIj5cclxuICAgICAgICAgICAgPHRleHRhcmVhIG1kSW5wdXQgcGxhY2Vob2xkZXI9XCJSZWxlYXNlIE5vdGVzXCIgdmFsdWU9XCJSZWxlYXNlTm90ZXNcIiBpZD1cIlJlbGVhc2VOb3Rlc1wiIFsobmdNb2RlbCldPVwidmVyc2lvbi5SZWxlYXNlTm90ZXNcIiBuYW1lPVwiUmVsZWFzZU5vdGVzXCI+XHJcbiAgICAgICAgICAgIDwvdGV4dGFyZWE+XHJcbiAgICAgICAgPC9tZC1pbnB1dC1jb250YWluZXI+XHJcbiAgICA8L2Rpdj5cclxuICAgIDxkaXYgbWRUb29sdGlwPVwiXCIgbWRUb29sdGlwUG9zaXRpb249XCJhZnRlclwiPlxyXG4gICAgICAgIDxtZC1pbnB1dC1jb250YWluZXIgY2xhc3M9XCJ2ZXJzaW9uLWZ1bGwtd2lkdGhcIj5cclxuICAgICAgICAgICAgPHRleHRhcmVhIG1kSW5wdXQgcGxhY2Vob2xkZXI9XCJFbmdpbmVlcmluZyBOb3Rlc1wiIHZhbHVlPVwiRW5nck5vdGVzXCIgaWQ9XCJFbmdyTm90ZXNcIiBbKG5nTW9kZWwpXT1cInZlcnNpb24uRW5nck5vdGVzXCIgbmFtZT1cIkVuZ3JOb3Rlc1wiPlxyXG4gICAgICAgICAgICA8L3RleHRhcmVhPlxyXG4gICAgICAgIDwvbWQtaW5wdXQtY29udGFpbmVyPlxyXG4gICAgPC9kaXY+XHJcbiAgICA8ZGl2IG1kVG9vbHRpcD1cIlwiIG1kVG9vbHRpcFBvc2l0aW9uPVwiYWZ0ZXJcIj5cclxuICAgICAgICA8bWQtaW5wdXQtY29udGFpbmVyIGNsYXNzPVwidmVyc2lvbi1mdWxsLXdpZHRoXCI+XHJcbiAgICAgICAgICAgIDxpbnB1dCBtZElucHV0IHBsYWNlaG9sZGVyPVwiUmVsZWFzZSBEYXRlXCIgW25nTW9kZWxdPVwidmVyc2lvbi5SZWxlYXNlRGF0ZSB8IGRhdGU6J3l5eXktTU0tZGQnXCIgKG5nTW9kZWxDaGFuZ2UpPVwidmVyc2lvbi5SZWxlYXNlRGF0ZSA9ICRldmVudFwiIHR5cGU9XCJkYXRlXCIgbmFtZT1cIlJlbGVhc2VEYXRlXCIgLz5cclxuICAgICAgICA8L21kLWlucHV0LWNvbnRhaW5lcj5cclxuICAgIDwvZGl2PlxyXG4gICAgPGRpdiBtZFRvb2x0aXA9XCJWZXJzaW9uIHJlbGVhc2Ugc3RhdHVzXCIgbWRUb29sdGlwUG9zaXRpb249XCJhZnRlclwiPlxyXG4gICAgICAgIDxtZC1zZWxlY3QgY2xhc3M9XCJ2ZXJzaW9uLWZ1bGwtd2lkdGhcIiBwbGFjZWhvbGRlcj1cIlJlbGVhc2UgU3RhdHVzXCIgWyhuZ01vZGVsKV09XCJ2ZXJzaW9uLlN0YXR1c1wiIG5hbWU9XCJTdGF0dXNcIj5cclxuICAgICAgICAgICAgPG1kLW9wdGlvbiAqbmdGb3I9XCJsZXQgc3RhdHVzIG9mIHJlbGVhc2VTdGF0dXNcIiBbdmFsdWVdPVwic3RhdHVzWzFdXCI+e3tzdGF0dXNbMF19fTwvbWQtb3B0aW9uPlxyXG4gICAgICAgIDwvbWQtc2VsZWN0PlxyXG4gICAgPC9kaXY+XHJcblxyXG4gICAgPGg0PkZpbGUgVXBsb2FkPC9oND5cclxuICAgIDxpbnB1dCBjbGFzcz1cInZlcnNpb24tdXBsb2FkXCIgdHlwZT1cImZpbGVcIiAoY2hhbmdlKT1cImZpbGVVcGxvYWQoJGV2ZW50KVwiIHBsYWNlaG9sZGVyPVwiVXBsb2FkXCIgYWNjZXB0PVwiLipcIiAvPlxyXG5cclxuICAgIDxkaXYgbWRUb29sdGlwPVwiXCIgbWRUb29sdGlwUG9zaXRpb249XCJhZnRlclwiPlxyXG4gICAgICAgIDxtZC1pbnB1dC1jb250YWluZXIgY2xhc3M9XCJ2ZXJzaW9uLWZ1bGwtd2lkdGhcIj5cclxuICAgICAgICAgICAgPGlucHV0IG1kSW5wdXQgcGxhY2Vob2xkZXI9XCJGaWxlIFVSTFwiIHZhbHVlPVwiVXJsXCIgaWQ9XCJVcmxcIiBkaXNhYmxlZCBbKG5nTW9kZWwpXT1cInZlcnNpb24uVXJsXCIgbmFtZT1cIlVybFwiIC8+XHJcbiAgICAgICAgPC9tZC1pbnB1dC1jb250YWluZXI+XHJcbiAgICA8L2Rpdj5cclxuICAgIDxkaXYgbWRUb29sdGlwPVwiXCIgbWRUb29sdGlwUG9zaXRpb249XCJhZnRlclwiPlxyXG4gICAgICAgIDxtZC1pbnB1dC1jb250YWluZXIgY2xhc3M9XCJ2ZXJzaW9uLWZ1bGwtd2lkdGhcIj5cclxuICAgICAgICAgICAgPGlucHV0IG1kSW5wdXQgcGxhY2Vob2xkZXI9XCJGaWxlIEhhc2hcIiB2YWx1ZT1cIkhhc2hcIiBpZD1cIkhhc2hcIiBkaXNhYmxlZCBbKG5nTW9kZWwpXT1cInZlcnNpb24uSGFzaFwiIG5hbWU9XCJIYXNoXCIgLz5cclxuICAgICAgICA8L21kLWlucHV0LWNvbnRhaW5lcj5cclxuICAgIDwvZGl2PlxyXG5cclxuICAgIDxoND5Qcm9kdWN0czwvaDQ+XHJcbiAgICA8bWQtaW5wdXQtY29udGFpbmVyPlxyXG4gICAgICAgIDxpbnB1dCBtZElucHV0IHBsYWNlaG9sZGVyPVwiTGlua2VkIFByb2R1Y3RzXCIgW21kQXV0b2NvbXBsZXRlXT1cImF1dG9cIiBbZm9ybUNvbnRyb2xdPVwicHJvZHVjdEN0cmxcIj5cclxuICAgIDwvbWQtaW5wdXQtY29udGFpbmVyPlxyXG4gICAgPG1kLWF1dG9jb21wbGV0ZSAjYXV0bz1cIm1kQXV0b2NvbXBsZXRlXCI+XHJcbiAgICAgICAgPG1kLW9wdGlvbiAqbmdGb3I9XCJsZXQgcHJvZHVjdCBvZiBmaWx0ZXJlZFByb2R1Y3RzIHwgYXN5bmNcIiBbdmFsdWVdPVwicHJvZHVjdC5OYW1lXCIgKG9uU2VsZWN0aW9uQ2hhbmdlKT1cIm9uUHJvZHVjdFNlbGVjdGVkKHByb2R1Y3QsICRldmVudClcIj5cclxuICAgICAgICAgICAge3sgcHJvZHVjdC5OYW1lIH19ICh7e3Byb2R1Y3QuVXBkYXRlSWR9fSlcclxuICAgICAgICA8L21kLW9wdGlvbj5cclxuICAgIDwvbWQtYXV0b2NvbXBsZXRlPlxyXG4gICAgPG1kLWNoaXAtbGlzdCBjbGFzcz1cInZlcnNpb24tZnVsbC13aWR0aFwiICNjaGlwTGlzdD5cclxuICAgICAgICA8bWQtY2hpcCAqbmdGb3I9XCJsZXQgcHJvZHVjdCBvZiBzZWxlY3RlZFByb2R1Y3RzXCIgZGlzYWJsZWQ+XHJcbiAgICAgICAgICAgIDxzcGFuPlxyXG4gICAgICAgICAgICAgICAgPHN0cm9uZz57e3Byb2R1Y3QuVXBkYXRlSWR9fTwvc3Ryb25nPlxyXG4gICAgICAgICAgICAgICAgPGVtPih7e3Byb2R1Y3QuTmFtZX19KTwvZW0+XHJcbiAgICAgICAgICAgIDwvc3Bhbj5cclxuICAgICAgICAgICAgPHNwYW4gKGNsaWNrKT1cInJlbW92ZVNlbGVjdGVkUHJvZHVjdChwcm9kdWN0KVwiPjxpIGNsYXNzPVwibWRpIG1kaS1jbG9zZS1jaXJjbGUtb3V0bGluZVwiPjwvaT48L3NwYW4+XHJcbiAgICAgICAgPC9tZC1jaGlwPlxyXG4gICAgPC9tZC1jaGlwLWxpc3Q+XHJcblxyXG4gICAgPGRpdj5cclxuICAgICAgICA8YnV0dG9uIG1kLXJhaXNlZC1idXR0b24gY2xhc3M9XCJ2ZXJzaW9uLWJ1dHRvblwiIChjbGljayk9XCJzYXZlVmVyc2lvbih2ZXJzaW9uLCBzZWxlY3RlZFByb2R1Y3RzKTtcIiBjb2xvcj1cInByaW1hcnlcIj5TYXZlPC9idXR0b24+XHJcbiAgICAgICAgPGJ1dHRvbiBtZC1yYWlzZWQtYnV0dG9uIGNsYXNzPVwidmVyc2lvbi1idXR0b25cIiAoY2xpY2spPVwiY2FuY2VsKCk7XCI+Q2FuY2VsPC9idXR0b24+XHJcbiAgICA8L2Rpdj5cclxuICAgIDxkaXYgY2xhc3M9XCJidXN5LW92ZXJsYXlcIiAqbmdJZj1cImJ1c3lcIj5cclxuICAgICAgICA8bWQtcHJvZ3Jlc3Mtc3Bpbm5lciBjbGFzcz1cImJ1c3ktc3Bpbm5lclwiXHJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY29sb3I9XCJ3aGl0ZVwiXHJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgbW9kZT1cImluZGV0ZXJtaW5hdGVcIj5cclxuICAgICAgICA8L21kLXByb2dyZXNzLXNwaW5uZXI+XHJcbiAgICA8L2Rpdj5cclxuXHJcbjwvZm9ybT5cclxuIiwiPHZlcnNpb25lZGl0PjwvdmVyc2lvbmVkaXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0lJO01BQUE7TUFBQTtnQkFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsdUNBQUE7TUFBQTthQUFBO2lFQUFBO1VBQUEsK0RBQW9HO1VBQUEsaUJBQ2hHO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSxxRUFBQTtVQUFBO2NBQUE7VUFBQTtVQUFBO1VBQUEsdUVBQUE7VUFBQTtvREFBQTtVQUFBLGVBQStDLHVDQUMzQztVQUFBO2NBQUE7Y0FBQTtjQUFBO2tCQUFBO2NBQUE7a0JBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQW9FO2NBQUE7Y0FBQTtZQUFBO1lBQXBFO1VBQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQSxvQ0FBQTtVQUFBO1VBQUE7YUFBQSxvRUFBQTtVQUFBO2FBQUE7VUFBQTtVQUFBO01BQXlHLG1DQUN4Rjs7O0lBSDBCO0lBQTlDO0lBQUwsV0FBbUQsVUFBOUMsU0FBTDtJQUN3QjtJQUFwQixZQUFvQixVQUFwQjtJQUNpRztJQUFsQztJQUFTO0lBQXBFLFlBQTZGLFdBQWxDLFdBQVMsVUFBcEU7SUFBMkQ7SUFBUjtJQUFwQztJQUFmLFlBQTJELFdBQVIsV0FBcEMsVUFBZjs7SUFESjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUE7UUFBQSwrQkFBQTtJQUNJO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsYUFBQTtRQUFBLFdBQUEsaUVBQUE7Ozs7b0JBaUNBO01BQUE7TUFBQTtVQUFBO1VBQUE7ZUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO0VBQUEscURBQUE7TUFBQTtVQUFBLGdDQUFBO01BQUE7TUFBb0U7SUFBcEI7SUFBaEQsV0FBZ0QsU0FBaEQ7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUE7UUFBQSxTQUFBO0lBQW9FO0lBQUE7Ozs7b0JBdUJ4RTtNQUFBO01BQUE7VUFBQTtVQUFBO01BQUE7SUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7SUFBQTtJQUFtRjtNQUFBO01BQUE7SUFBQTtJQUFuRjtFQUFBLHFEQUFBO01BQUE7VUFBQSwwREFBQTtNQUFBO01BQUEsZUFBNEk7O0lBQWhGO0lBQTVELFdBQTRELFNBQTVEOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBO1FBQUEsU0FBQTtJQUE0STtJQUFBO0lBQUE7Ozs7b0JBSzVJO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtFQUFBLHVDQUFBO01BQUE7YUFBQTtVQUFBLDRCQUEyRDtNQUN2RDtVQUFBLDBEQUFNO1VBQUEseUJBQ0Y7VUFBQTtVQUFBLGdCQUFRLHdDQUE2QjtVQUFBLHlCQUNyQztVQUFBO1VBQUEsZ0JBQUksMENBQXVCO1VBQUEscUJBQ3hCO01BQ1A7VUFBQTtZQUFBO1lBQUE7WUFBTTtjQUFBO2NBQUE7WUFBQTtZQUFOO1VBQUEsZ0NBQStDO1VBQUE7VUFBQSxtREFBQTtVQUFBO29EQUFBO1VBQUEsZUFBbUQ7SUFMcEQ7SUFBbEQsV0FBa0QsU0FBbEQ7SUFLc0Q7SUFBSCxZQUFHLFNBQUg7O0lBTG5EO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7SUFFZ0I7SUFBQTtJQUNKO0lBQUE7Ozs7b0JBVWhCO01BQUE7YUFBQTttRUFBQTtVQUFBLDZCQUF1QztNQUNuQztVQUFBO1VBQUE7VUFBQTt5Q0FBQSxVQUFBO1VBQUE7VUFBQSxzQkFBQTtVQUFBLGtEQUFBO1VBQUE7b0RBQUE7VUFBQSxlQUU2QywrQ0FDdkI7VUFBQTtJQUpyQjtJQUFMLFdBQUssU0FBTDtJQUU0QjtJQUNBO0lBRnhCLFdBQ3dCLFVBQ0EsU0FGeEI7SUFBcUI7SUFBckIsV0FBcUIsU0FBckI7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBLHVDQUFBOzs7OzBEQWpGUjtNQUFBO01BQUEsOEJBQUk7TUFBbUIsdUNBQ3ZCO1VBQUE7VUFBQTtjQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEsdUNBQUE7VUFBQSxvQ0FBQTtVQUFBLHNFQUFBO1VBQUEsb0VBQUE7VUFBQTtVQUFBLHNCQUFBO3NGQUFBO1VBQUEsMkNBQXFEO1VBQUEsYUFDakQ7VUFBQTtNQUFJLHVEQUF1QjtVQUFBLGVBRTNCO1VBQUEscUNBQUE7d0JBQUEsbUNBSU07VUFBQSxhQUNOO1VBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSx1Q0FBQTtVQUFBO2FBQUE7aUVBQUE7VUFBQSwrREFBb0Y7VUFBQSxpQkFDaEY7VUFBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHFFQUFBO1VBQUE7Y0FBQTtVQUFBO1VBQUE7VUFBQSx5RUFBQTtVQUFBO29EQUFBO1VBQUEsZUFBK0MsdUNBQzNDO1VBQUE7Y0FBQTtjQUFBO2NBQUE7Y0FBQTtrQkFBQTtrQkFBQTtrQkFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBd0Y7Y0FBQTtjQUFBO1lBQUE7WUFBeEY7VUFBQSx1Q0FBQTtVQUFBO1VBQUEsc0JBQUE7VUFBQSxnREFBQTtVQUFBO1lBQUE7VUFBQTtVQUFBO1lBQUE7VUFBQSxvQ0FBQTs2QkFBQTtVQUFBLHFFQUFBO1VBQUEsOERBQUE7VUFBQSx3RUFBQTtVQUFBOzBCQUFBO1VBQUE7TUFBK0ksbUNBQzlIO01BQ25CLDJDQUNOO1VBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSx1Q0FBQTtVQUFBO2FBQUE7aUVBQUE7VUFBQSwrREFBdUg7VUFBQSxpQkFDbkg7VUFBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHFFQUFBO1VBQUE7Y0FBQTtVQUFBO1VBQUE7VUFBQSx5RUFBQTtVQUFBO29EQUFBO1VBQUEsZUFBK0MsdUNBQzNDO1VBQUE7Y0FBQTtjQUFBO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO2tCQUFBO2NBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQThGO2NBQUE7Y0FBQTtZQUFBO1lBQTlGO1VBQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBO1VBQUEsZ0RBQUE7OEJBQUE7YUFBQTtRQUFBO01BQUE7VUFBQTtZQUFBO1VBQUEsb0NBQUE7NkJBQUE7VUFBQSxxRUFBQTtVQUFBLDhEQUFBO1VBQUEsd0VBQUE7VUFBQTswQkFBQTtVQUFBO01BQW9MLG1DQUNuSztNQUNuQiw2Q0FFTjtVQUFBO1VBQUE7dUJBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHVDQUFBO1VBQUE7YUFBQTtpRUFBQTtVQUFBLCtEQUE0QztVQUFBLGlCQUN4QztVQUFBO2NBQUE7Y0FBQTtrQkFBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEscUVBQUE7VUFBQTtjQUFBO1VBQUE7VUFBQTtVQUFBLHlFQUFBO1VBQUE7b0RBQUE7VUFBQSxlQUErQyx1Q0FDM0M7VUFBQTtjQUFBO2NBQUE7Y0FBQTtjQUFBO2tCQUFBO2tCQUFBO2NBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQXFGO2NBQUE7Y0FBQTtZQUFBO1lBQXJGO1VBQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQSxvQ0FBQTtVQUFBO1VBQUEsb0RBQUE7dUJBQUEsbUNBQUE7VUFBQSxtREFBQTtVQUFBO21DQUFBO2NBQUEsOENBQTRJO1VBQUEsbUJBQ2pJLG1DQUNNO1VBQUEsYUFDbkIsMkNBQ047VUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHVDQUFBO1VBQUE7YUFBQTtpRUFBQTtVQUFBLCtEQUE0QztVQUFBLGlCQUN4QztVQUFBO2NBQUE7Y0FBQTtrQkFBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEscUVBQUE7VUFBQTtjQUFBO1VBQUE7VUFBQTtVQUFBLHlFQUFBO1VBQUE7b0RBQUE7VUFBQSxlQUErQyx1Q0FDM0M7VUFBQTtjQUFBO2NBQUE7Y0FBQTtjQUFBO2tCQUFBO2tCQUFBO2NBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQW1GO2NBQUE7Y0FBQTtZQUFBO1lBQW5GO1VBQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBO1FBQUE7TUFBQSxvQ0FBQTtVQUFBO1VBQUEsb0RBQUE7dUJBQUEsbUNBQUE7VUFBQSxtREFBQTtVQUFBO21DQUFBO2NBQUEsOENBQW9JO1VBQUEsbUJBQ3pILG1DQUNNO1VBQUEsYUFDbkIsMkNBQ047VUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHVDQUFBO1VBQUE7YUFBQTtpRUFBQTtVQUFBLCtEQUE0QztVQUFBLGlCQUN4QztVQUFBO2NBQUE7Y0FBQTtrQkFBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEscUVBQUE7VUFBQTtjQUFBO1VBQUE7VUFBQTtVQUFBLHlFQUFBO1VBQUE7b0RBQUE7VUFBQSxlQUErQyx1Q0FDM0M7VUFBQTtjQUFBO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO2tCQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUE4RjtjQUFBO2NBQUE7WUFBQTtZQUE5RjtVQUFBLHVDQUFBO1VBQUE7VUFBQSxzQkFBQTtRQUFBO01BQUEsb0NBQUE7VUFBQTtVQUFBLG9EQUEwQyxXQUExQzt1QkFBQSxtQ0FBQTtVQUFBLG1EQUFBO1VBQUE7bUNBQUE7Y0FBQSwrQ0FBOEs7TUFDN0osMkNBQ25CO01BQ047VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSx1Q0FBQTtVQUFBO2FBQUE7aUVBQUE7VUFBQSwrREFBa0U7VUFBQSxpQkFDOUQ7VUFBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtrQkFBQTtjQUFBO1VBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQW1FO2NBQUE7Y0FBQTtZQUFBO1lBQW5FO1VBQUEscURBQUE7VUFBQTtjQUFBO2FBQUEsb0VBQUE7VUFBQTthQUFBO3VCQUFBLHNDQUFBO1VBQUE7Y0FBQTtVQUFBO2FBQUEsdUNBQUE7VUFBQTswQkFBQSw2Q0FBOEc7VUFBQSxxQkFDMUc7VUFBQSxxQ0FBQTtVQUFBO1VBQUEsZUFBNkYsbUNBQ3JGO1VBQUEsYUFDViw2Q0FFTjtVQUFBO1VBQUEsNENBQUk7VUFBQSxrQkFBZ0IsMkNBQ3BCO1VBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUEwQztjQUFBO2NBQUE7WUFBQTtZQUExQztVQUFBLHVDQUFBO1VBQUE7MEJBQUEsNkNBQTJHO1VBQUEsZUFFM0c7VUFBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSx1Q0FBQTtVQUFBO2FBQUE7aUVBQUE7VUFBQSwrREFBNEM7VUFBQSxpQkFDeEM7VUFBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHFFQUFBO1VBQUE7Y0FBQTtVQUFBO1VBQUE7VUFBQSx5RUFBQTtVQUFBO29EQUFBO1VBQUEsZUFBK0MsdUNBQzNDO1VBQUE7Y0FBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtrQkFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBb0U7Y0FBQTtjQUFBO1lBQUE7WUFBcEU7VUFBQSx1Q0FBQTtVQUFBO1VBQUEsc0JBQUE7UUFBQTtNQUFBLG9DQUFBO1VBQUE7VUFBQTthQUFBLG9FQUFBO1VBQUE7YUFBQTtVQUFBO1VBQUE7TUFBMkcsbUNBQzFGO01BQ25CLDJDQUNOO1VBQUE7VUFBQTt1QkFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEsdUNBQUE7VUFBQTthQUFBO2lFQUFBO1VBQUEsK0RBQTRDO1VBQUEsaUJBQ3hDO1VBQUE7Y0FBQTtjQUFBO2tCQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSxxRUFBQTtVQUFBO2NBQUE7VUFBQTtVQUFBO1VBQUEseUVBQUE7VUFBQTtvREFBQTtVQUFBLGVBQStDLHVDQUMzQztVQUFBO2NBQUE7Y0FBQTtjQUFBO2NBQUE7a0JBQUE7a0JBQUE7Y0FBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBdUU7Y0FBQTtjQUFBO1lBQUE7WUFBdkU7VUFBQSx1Q0FBQTtVQUFBO1VBQUEsc0JBQUE7UUFBQTtNQUFBLG9DQUFBO1VBQUE7VUFBQTthQUFBLG9FQUFBO1VBQUE7YUFBQTtVQUFBO1VBQUE7TUFBZ0gsbUNBQy9GO01BQ25CLDZDQUVOO1VBQUE7VUFBQSw4QkFBSTtNQUFhLDJDQUNqQjtVQUFBO2NBQUE7Y0FBQTtrQkFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSxxRUFBQTtVQUFBO2NBQUE7VUFBQTtVQUFBO1VBQUEsa0VBQW9CO2lCQUFBLG9CQUNoQjtVQUFBO2NBQUE7Y0FBQTtjQUFBO2NBQUE7Y0FBQTtrQkFBQTtrQkFBQTtjQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBO3dFQUFBO1VBQUE7VUFBQSxzQkFBQTtrQkFBQTtRQUFBO01BQUEsNkRBQUE7VUFBQTtVQUFBLHdDQUFBO1VBQUEsZ0RBQUE7VUFBQSxtREFBQTtVQUFBO21DQUFBO2NBQUEsK0JBQWlHLCtCQUNoRjtpQkFBQSw0QkFDckI7VUFBQTtVQUFBLDZFQUFBO1VBQUE7MkJBQUEsc0NBQUE7VUFBQTthQUFBLDJCQUF3QyxtQ0FDcEM7aUJBQUE7YUFBQTs0QkFBQSxnREFBVzt1QkFBQSx3QkFFQywrQkFDRTtpQkFBQSw0QkFDbEI7VUFBQTtVQUFBO3VCQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSx5REFBQTtVQUFBO1VBQUEscUJBQUE7c0ZBQUE7VUFBQSwyQ0FBbUQ7TUFDL0M7YUFBQTs0QkFBQSx5Q0FNVTtVQUFBLGFBQ0MsNkNBRWY7VUFBQTtVQUFBLDRDQUFLO1VBQUEsaUJBQ0Q7VUFBQTtjQUFBO1lBQUE7WUFBQTtZQUFnRDtjQUFBO2NBQUE7WUFBQTtZQUFoRDtVQUFBLHFEQUFBO1VBQUE7VUFBQSxvQ0FBQTtVQUFBO2NBQUEsZ0NBQUE7VUFBQSxrREFBQTtVQUFBO29EQUFBO1VBQUEsZUFBa0gsNkJBQWE7VUFBQSxpQkFDL0g7VUFBQTtjQUFBO1lBQUE7WUFBQTtZQUFnRDtjQUFBO2NBQUE7WUFBQTtZQUFoRDtVQUFBLHFEQUFBO1VBQUE7VUFBQSxvQ0FBQTtVQUFBO1VBQUEsc0JBQUE7VUFBQSxrREFBQTtVQUFBO29EQUFBO1VBQUEsZUFBb0UsK0JBQWU7VUFBQSxhQUNqRiwyQ0FDTjtVQUFBO2FBQUE7VUFBQSx3QkFLTSx5Q0FFSDtpQkFBQTs7SUF0RkQ7SUFBTixXQUFNLFNBQU47SUFHaUY7SUFBN0UsWUFBNkUsU0FBN0U7SUFLMEQ7SUFBckQ7SUFBTCxZQUEwRCxVQUFyRCxVQUFMO0lBQ3dCO0lBQXBCLFlBQW9CLFVBQXBCO0lBQ21GO0lBQS9FLFlBQStFLFVBQS9FO0lBQTBIO0lBQWxDO0lBQXhGLFlBQTBILFdBQWxDLFVBQXhGO0lBQThEO0lBQS9DO0lBQWdFO0lBQS9FLFlBQThELFdBQS9DLFdBQWdFLFVBQS9FO0lBR3FGO0lBQXhGO0lBQUwsWUFBNkYsV0FBeEYsVUFBTDtJQUN3QjtJQUFwQixZQUFvQixVQUFwQjtJQUN5RjtJQUFyRixZQUFxRixVQUFyRjtJQUF1SjtJQUF2SixZQUF1SixVQUF2SjtJQUFrSTtJQUFwQztJQUE5RixZQUFrSSxXQUFwQyxVQUE5RjtJQUFrRTtJQUFuRDtJQUFzRTtJQUFyRixZQUFrRSxXQUFuRCxXQUFzRSxVQUFyRjtJQUlVO0lBQWI7SUFBTCxZQUFrQixXQUFiLFVBQUw7SUFDd0I7SUFBcEIsWUFBb0IsVUFBcEI7SUFDNEg7SUFBbkM7SUFBckYsWUFBd0gsWUFBbkMsV0FBckY7SUFBbUU7SUFBakQ7SUFBbEIsWUFBbUUsWUFBakQsV0FBbEI7SUFJVTtJQUFiO0lBQUwsWUFBa0IsWUFBYixXQUFMO0lBQ3dCO0lBQXBCLGFBQW9CLFdBQXBCO0lBQ3VIO0lBQWhDO0lBQW5GLGFBQW1ILFlBQWhDLFdBQW5GO0lBQW9FO0lBQWxEO0lBQWxCLGFBQW9FLFlBQWxELFdBQWxCO0lBSVU7SUFBYjtJQUFMLGFBQWtCLFlBQWIsV0FBTDtJQUN3QjtJQUFwQixhQUFvQixXQUFwQjtJQUM2SjtJQUEvRztRQUFBO0lBQTFDLGFBQXlKLFlBQS9HLFdBQTFDO0lBQWU7SUFBOEg7SUFBN0ksYUFBZSxZQUE4SCxXQUE3STtJQUdnQztJQUFuQztJQUFMLGFBQXdDLFlBQW5DLFdBQUw7SUFDb0c7SUFBN0I7SUFBbkUsYUFBZ0csWUFBN0IsV0FBbkU7SUFBc0M7SUFBdEMsYUFBc0MsV0FBdEM7SUFBVztJQUFYLGFBQVcsV0FBWDtJQUNlO0lBQVgsYUFBVyxXQUFYO0lBS0Q7SUFBUCxhQUFPLFdBQVA7SUFFa0I7SUFBYjtJQUFMLGFBQWtCLFlBQWIsV0FBTDtJQUN3QjtJQUFwQixhQUFvQixXQUFwQjtJQUNrRztJQUFuQztJQUFTO0lBQXBFLGFBQThGLFlBQW5DLFlBQVMsV0FBcEU7SUFBMkQ7SUFBVDtJQUFuQztJQUFmLGFBQTJELFlBQVQsWUFBbkMsV0FBZjtJQUdVO0lBQWI7SUFBTCxhQUFrQixZQUFiLFdBQUw7SUFDd0I7SUFBcEIsYUFBb0IsV0FBcEI7SUFDc0c7SUFBcEM7SUFBUztJQUF2RSxhQUFrRyxZQUFwQyxZQUFTLFdBQXZFO0lBQThEO0lBQVY7SUFBckM7SUFBZixhQUE4RCxZQUFWLFlBQXJDLFdBQWY7SUFNeUM7SUFBN0MsYUFBNkMsV0FBN0M7SUFBcUU7SUFBckUsYUFBcUUsV0FBckU7SUFBZTtJQUFmLGFBQWUsV0FBZjtJQUdXO0lBQVgsYUFBVyxXQUFYO0lBSVU7SUFBZCxhQUFjLFdBQWQ7SUFDYTtJQUFULGFBQVMsV0FBVDtJQVVrRztJQUFsRyxhQUFrRyxXQUFsRztJQUF5QjtJQUF6QixhQUF5QixXQUF6QjtJQUN5QjtJQUF6QixhQUF5QixXQUF6QjtJQUVzQjtJQUExQixhQUEwQixXQUExQjs7SUEvRUo7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBLHFFQUFBO0lBU1E7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxZQUFBO1FBQUEsMkNBQUE7SUFDSTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsYUFBQSxXQUFBO1FBQUEsc0JBQUE7UUFBQSxVQUFBO0lBSUo7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxZQUFBO1FBQUEsMkNBQUE7SUFDSTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxhQUFBLFdBQUEsV0FBQTtRQUFBLGlDQUFBO1FBQUEscUJBQUE7SUFLSjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFlBQUE7UUFBQSwyQ0FBQTtJQUNJO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsYUFBQTtRQUFBLFdBQUEsb0VBQUE7SUFLSjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFlBQUE7UUFBQSwrQ0FBQTtJQUNJO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsY0FBQTtRQUFBLFlBQUEsdUVBQUE7SUFLSjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLGFBQUE7UUFBQSwrQ0FBQTtJQUNJO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsY0FBQTtRQUFBLFlBQUEsdUVBQUE7SUFJSjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtRQUFBO0lBQUE7SUFBQTtJQUFBLGNBQUE7UUFBQSxZQUFBO1FBQUEsdUJBQUE7SUFTQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLGFBQUE7UUFBQSwrQ0FBQTtJQUNJO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsY0FBQTtRQUFBLFlBQUEsdUVBQUE7SUFJSjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLGFBQUE7UUFBQSwrQ0FBQTtJQUNJO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsY0FBQTtRQUFBLFlBQUEsdUVBQUE7SUFLUjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLGFBQUE7UUFBQSwrQ0FBQTtJQUNJO1FBQUE7SUFBQTtJQUFBO1FBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLGNBQUEsb0NBQUE7UUFBQSxnREFBQTtRQUFBLG1DQUFBO0lBT0o7SUFBQSxhQUFBLFdBQUE7SUFXSTtJQUFBLGFBQUEsV0FBQTtJQUNBO0lBQUEsYUFBQSxXQUFBOzs7O29CQzlFUjtNQUFBO3FDQUFBO3NCQUFBLG9DQUFBO01BQUE7TUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./Client/$$_gendir/app/containers/versionedit/versionedit.component.ngfactory.ts